import { abyssColors } from '@/theme/colors';
import { Button, DialogContent, Stack, Typography, styled as muiStyled } from '@mui/material';

export const modalStyles = {
  borderRadius: '0px',
  background: abyssColors.neutral[50],
  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.15)',
  overflow: 'hidden',
  maxWidth: '536px',
  minHeight: '500px',
  transform: 'none',
};

export const titleStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '3.2rem',
  fontSize: '2rem',
  fontWeight: 600,
  lineHeight: 'normal',
  color: abyssColors.primary[500],
};

export const paperStyles = {
  width: '100%',
  maxWidth: '53.6rem',
  minHeight: '50rem',
  maxHeight: '80rem',
  borderRadius: '0.8rem',
};

export const contentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2.4rem',
  padding: '0',
  overflow: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
};

export const headerStyles = {
  padding: '32px',
  '& h5': {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 'normal',
    color: abyssColors.primary[500],
  },
  '& button': {
    padding: 0,
  },
};

export const crossIconStyles = {
  fontSize: '2.4rem',
  color: abyssColors.primary[500],
  background: 'none',
};

export const SectionTitle = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  fontSize: '1.2rem',
  fontWeight: 500,
}));

type ButtonProps = {
  contained?: boolean;
};

export const ActionButton = muiStyled(Button)(({ contained }: ButtonProps) => ({
  padding: '4px 12px',
  height: '26px',
  borderRadius: '4px',
  fontSize: '1.2rem',
  background: contained ? abyssColors.primary[500] : abyssColors.neutral[50],
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  gap: '0.8rem',
  ...(contained ? {} : { border: `1px solid ${abyssColors.primary[500]} !important` }),
}));

export const SelectionDialogContent = muiStyled(DialogContent)(() => ({
  borderBottom: `1px solid ${abyssColors.primary[100]}`,
  overflowY: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  paddingTop: 0,
  '&::-webkit-scrollbar': { display: 'none' },
}));

export const SelectionDialogActions = muiStyled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%',
  padding: '16px',
}));

export const tooltipStyles = {
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#000000B8',
    color: abyssColors.primary[50],
    opacity: 1,
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
  },
  '& .MuiTooltip-arrow': {
    color: '#000000B8',
  },
};
